export default __webpack_public_path__ + "static/media/Investigacion.0a3a2a8b.jpg";